// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BreadCrumb {
  padding-top: 20px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.BreadCrumb-link {
  display: flex;
  align-items: center;
  color: var(--gray);
}
.BreadCrumb-title {
  color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/components/BreadCrumb/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAEE;EACE,+BAAA;AAAJ","sourcesContent":[".BreadCrumb {\n  padding-top: 20px;\n  width: fit-content;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n\n  &-link {\n    display: flex;\n    align-items: center;\n    color: var(--gray);\n  }\n\n  &-title {\n    color: var(--color_primary_500);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
